import { useEffect, useState } from 'react';
import { contabilidadApi } from '../utils/api';
import useAuthStore from '../store/authStore';

/**
 * Los períodos contables de la empresa, para el selector de los reportes
 * (S2-02). Si no cargan, la lista queda vacía y el selector sigue con meses y
 * fechas, como antes: un reporte no se rompe por un filtro.
 */
export default function usePeriodosContables() {
  const { currentEmisor } = useAuthStore();
  const [periodos, setPeriodos] = useState([]);
  useEffect(() => {
    if (!currentEmisor) return;
    contabilidadApi.getPeriodos()
      .then(r => setPeriodos(r.data?.data || []))
      .catch(() => setPeriodos([]));
  }, [currentEmisor]);
  return periodos;
}
